import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconCircleCheck: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 18 18" name="circle-check">
    <circle cx="9" cy="9" r="9" fill="#37967A" />
    <path
      d="M14.5303 6.03027L7.5 13.0605L3.96973 9.53027L5.03027 8.46973L7.5 10.9395L13.4697 4.96973L14.5303 6.03027Z"
      fill="white"
    />
  </Icon>
);
